import { getView, requireAuth } from '@/lib/utils';
import { MaterialsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/chemicals',
  component: getView('pages/PageChemicals'),
  name: 'chemicals',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Chemicals',
    leftMenu: Left.ChemicalsList,
    roles: ['operator'],
    information: MaterialsPage,
    showBottomMenu: true,
  },
};
